interface IPdfBody {
  body: any | undefined;
}

function PdfBody(props: IPdfBody) {
  return props.body;
}

export default PdfBody;
